import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {AuthConfig, OAuthModule, OAuthModuleConfig, OAuthService, OAuthStorage} from 'angular-oauth2-oidc';
import {authConfig} from './auth.config';
import {authModuleConfig} from './auth-module.config';
import {AuthService} from '../../services/auth/auth.service';

// We need a factory since localStorage is not available at AOT build time
export function storageFactory(): OAuthStorage {
  return localStorage;
}

@NgModule({ imports: [OAuthModule.forRoot()], providers: [
        AuthService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AuthModule {

  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        {provide: AuthConfig, useValue: authConfig},
        {provide: OAuthModuleConfig, useValue: authModuleConfig},
        {provide: OAuthStorage, useFactory: storageFactory},
      ]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: AuthModule, private readonly oauthService: OAuthService) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
    this.oauthService.configure(authConfig);
    this.oauthService.setupAutomaticSilentRefresh();
  }
}
